export enum InflightRuleType {
  VOLUME_PER_MINUTE,
  SMALL_REMAINDER_CANCEL,
  END_OF_DAY_ACTION,
  MARKET_RATE_CHANGE,
}

export namespace InflightRuleType {
  let elements = [
    InflightRuleType.VOLUME_PER_MINUTE,
    InflightRuleType.SMALL_REMAINDER_CANCEL,
    InflightRuleType.END_OF_DAY_ACTION,
    InflightRuleType.MARKET_RATE_CHANGE,
  ];
  let alias = "com.bcdfx.model.InflightRuleType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
